'use client';

import { c as _c } from "react/compiler-runtime";
import { type CookieAttributes, cookies } from '@repo/utils';
import { useCallback, useState } from 'react';

/**
 * Hook to read and write cookies.
 *
 * @param name The name of the cookie.
 * @param defaultValue The default value of the cookie.
 * @returns An object with the current value of the cookie, an `updateCookie` function to update its value and a `deleteCookie` function to delete the cookie.
 */
export function useCookie(name, defaultValue) {
  const $ = _c(11);
  let t0;
  if ($[0] !== defaultValue || $[1] !== name) {
    t0 = () => {
      const cookie = cookies.get(name);
      if (cookie) {
        return cookie;
      }
      if (defaultValue) {
        cookies.set(name, defaultValue);
      }
      return defaultValue;
    };
    $[0] = defaultValue;
    $[1] = name;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [value, setValue] = useState(t0);
  let t1;
  if ($[3] !== name) {
    t1 = (newValue, options) => {
      cookies.set(name, newValue, options);
      setValue(newValue);
    };
    $[3] = name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const updateCookie = t1;
  let t2;
  if ($[5] !== name) {
    t2 = () => {
      cookies.remove(name);
      setValue(undefined);
    };
    $[5] = name;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const deleteCookie = t2;
  let t3;
  if ($[7] !== deleteCookie || $[8] !== updateCookie || $[9] !== value) {
    t3 = {
      value,
      updateCookie,
      deleteCookie
    };
    $[7] = deleteCookie;
    $[8] = updateCookie;
    $[9] = value;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}